import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";

import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import HowItWorks from "@/components/HowItWorks";
import Products from "@/components/Products";
import BridgePromo from "@/components/BridgePromo";
import LabBreak from "@/components/LabBreak";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import ApplyForm from "@/components/ApplyForm";
import Footer from "@/components/Footer";
import ApplyPage from "@/pages/ApplyPage";
import BridgePage from "@/pages/BridgePage";
import AdminPage from "@/pages/AdminPage";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] p-8">
          <div className="max-w-md text-center">
            <p className="font-display text-2xl font-bold text-[#0A1628]">Something short-circuited.</p>
            <p className="mt-3 text-[#52525B]">Please refresh the page — the robot is on it.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = () => (
  <div className="relative">
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <HowItWorks />
      <Products />
      <BridgePromo />
      <LabBreak />
      <Testimonials />
      <FAQ />
      <ApplyForm />
    </main>
    <Footer />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apply" element={<ApplyPage />} />
            <Route path="/bridge" element={<BridgePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}

export default App;
